<template>
    <div class="my-10">
        <div class="flex flex-col">
            <div class="rounded-lg bg-white mb-4 flex justify-between gap-10 p-4">
                <h1 class="font-bold text-2xl text-main-color">{{ detail?.title }}</h1>
                <span class="flex items-center gap-1 text-main-color"><IconEye></IconEye>{{ detail?.view_count }}</span>
            </div>
            <div class="flex flex-col rounded-lg mb-4 overflow-hidden">
                <video v-if="detail?.media?.includes('.mp4', '.mov', '.avi', '.mkv', '.webm')" controlsList="nodownload" controls :src="detail?.media"
                class="object-contain w-full h-[30rem]" alt=""></video>
                <img v-else :src="detail?.media"
                    class="h-[30rem] w-full object-cover rounded-md cursor-pointer" alt="">
            </div>
            <div class="flex flex-col" v-html="detail?.content">
                
            </div>
            <a class="mt-4" v-for="phone in detail?.phone_numbers" :key="phone" :href="`tel:${phone}`">{{ phone }}</a>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import IconEye from '@icons/IconEye.vue'
export default {
    name: 'adAccount',
    components: {
        IconEye
    },
    data(){
        return {
            loading: false,
            detail: {}
        }
    },
    methods: {
        async getAd(){
            this.loading = true
            try{ 
                const response = await api.get(`commercials/ad_accounts/${this.$route.params.id}`)
                this.detail = response.data
            }
            catch(e){
                console.log(e)
            }
            this.loading = false
        }
    },
    computed: {

    },
    created(){
        this.getAd()
    }
}

</script>